import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["anchor", "avatarSrc", "children", "closeButton", "height", "onClick", "onClose", "open", "sheetVariant", "title", "titleInfo", "triggerComponent", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import { ICON_SIZES } from '../../../constants/constant';
import TAGSvgIcon from '../TAGSvgIcon/TAGSvgIcon';
import TAGNavContainer from './TAGNavContainer';
import TAGNavHeaderContent from './TAGNavHeaderContent';

var TAGNavigation = function TAGNavigation(_ref) {
  var anchor = _ref.anchor,
      avatarSrc = _ref.avatarSrc,
      children = _ref.children,
      _ref$closeButton = _ref.closeButton,
      closeButton = _ref$closeButton === void 0 ? false : _ref$closeButton,
      height = _ref.height,
      onClick = _ref.onClick,
      onClose = _ref.onClose,
      open = _ref.open,
      _ref$sheetVariant = _ref.sheetVariant,
      sheetVariant = _ref$sheetVariant === void 0 ? 'outlined' : _ref$sheetVariant,
      title = _ref.title,
      titleInfo = _ref.titleInfo,
      triggerComponent = _ref.triggerComponent,
      width = _ref.width,
      props = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      position = _React$useState2[0],
      setPosition = _React$useState2[1];

  var toggleDrawer = function toggleDrawer(anchor, open) {
    return function () {
      setPosition(_objectSpread(_objectSpread({}, position), {}, _defineProperty({}, anchor, open)));
    };
  };

  var TriggerDivWrapper = function TriggerDivWrapper() {
    return React.createElement('div', _objectSpread({
      onClick: onClick !== undefined ? onClick : toggleDrawer(anchor, true),
      anchor: anchor,
      style: {
        cursor: 'pointer',
        width: 'fit-content',
        height: 'fit-content'
      },
      'data-test': 'testingDiv'
    }, props), triggerComponent);
  };

  return React.createElement(React.Fragment, {
    key: anchor
  }, React.createElement(Drawer, _objectSpread(_objectSpread({}, props), {}, {
    PaperProps: {
      variant: sheetVariant,
      sx: {
        maxWidth: anchor === 'top' || anchor === 'bottom' ? 'auto' : '80%',
        maxHeight: anchor === 'top' || anchor === 'bottom' ? '80%' : 'auto',
        minWidth: 240,
        marign: '2px',
        width: width,
        height: height
      }
    },
    "data-test": "testDrawer",
    anchor: anchor,
    elevation: sheetVariant === 'elevation' ? 5 : 0,
    open: open !== undefined ? open : position[anchor],
    onClose: onClose !== undefined ? onClose : toggleDrawer(anchor, false)
  }), (title || avatarSrc) && React.createElement(TAGNavContainer, {
    divider: true
  }, React.createElement(TAGNavHeaderContent, {
    title: title,
    avatarSrc: avatarSrc,
    titleInfo: titleInfo
  })), React.createElement("div", {
    "data-test": "testLayout",
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, closeButton && React.createElement(IconButton, {
    onClick: onClose !== undefined ? onClose : toggleDrawer(anchor, false),
    sx: {
      position: 'absolute',
      right: 1,
      top: 1,
      zIndex: 3
    }
  }, React.createElement(TAGSvgIcon, {
    icon: "Times",
    size: ICON_SIZES.sm
  }))), React.Children.map(children, function (child) {
    return React.isValidElement(child) && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    React.cloneElement(child, {
      onCloseDrawer: onClose !== undefined ? onClose : toggleDrawer(anchor, false)
    });
  })), TriggerDivWrapper());
};

export default TAGNavigation;